var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgBellNotification = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 81,
    viewBox: "0 0 80 81",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M63.3333 39.8013C61.6667 40.2347 60 40.5013 58.3333 40.5013C53.4737 40.4925 48.8157 38.5581 45.3794 35.1219C41.9432 31.6856 40.0088 27.0276 40 22.168C40 17.268 41.9333 12.8347 45 9.53465C44.3951 8.79312 43.6323 8.19589 42.7674 7.78647C41.9024 7.37705 40.957 7.16575 40 7.16799C36.3333 7.16799 33.3333 10.168 33.3333 13.8347V14.8013C23.4333 17.7347 16.6667 26.8347 16.6667 37.168V57.168L10 63.8347V67.168H70V63.8347L63.3333 57.168V39.8013ZM40 77.168C43.7 77.168 46.6667 74.2013 46.6667 70.5013H33.3333C33.3333 72.2694 34.0357 73.9651 35.286 75.2154C36.5362 76.4656 38.2319 77.168 40 77.168Z",
    fill: "#89CC21"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M58.3346 33.8333C64.768 33.8333 70.0013 28.6 70.0013 22.1667C70.0013 15.7333 64.768 10.5 58.3346 10.5C51.9013 10.5 46.668 15.7333 46.668 22.1667C46.668 28.6 51.9013 33.8333 58.3346 33.8333Z",
    fill: "#E74040"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgBellNotification, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/bell-notification.e1e7b0b5.svg";
export { ForwardRef as ReactComponent };